import { AddBankAccountTask } from '../../common/tasks/AddBankAccountTask';
import { ServiceRequestSendEmailCardTask } from '../../common/tasks/ServiceRequestSendEmailCardTask';
import { ApproveCompanyDetails } from '../common/ApproveCompanyDetails';
import { EINLetter } from '../common/EINLetter';
import { EINProof } from '../common/EINProof';
import { FillCompanyDetails } from '../common/FillCompanyDetails';
import { IncorporationDetails } from '../common/IncorporationDetails';
import { MarkAsFiledComponent } from '../common/MarkAsFiled';
import { USUploadIncorporationDocuments } from '../common/UploadIncorporationDocuments';
import { BankStatements } from './components/BankStatements';
import { ClientUploadsSignedDocs } from './components/ClientUploadSignedDocuments';
import { SendBylawsForReview } from './components/SendBylawsForReview';
import { ShareHoldingInstructions } from './components/ShareHoldingInstructions';
import { ShareHoldingUploadDocuments } from './components/UploadShareHoldingDocuments';
import { UploadSignedBylaws } from './components/UploadSignedBylaws';
import { VerifyBankStatements } from './components/VerifyBankStatements';
import { VerifyDocuments } from './components/VerifyDocuments';
import { USCCORPIncorporationTasks } from './config';
import { BankWireInstructionsUpload } from '../common/BankWireInstructionsUpload';
import { BOIFilingAcknowledgementUpload } from '../common/BOIAckUpload';
export const US_CCORP_INCORPORATION_COMPONENT_MAP = {
  // Company Formation Details
  [USCCORPIncorporationTasks.FILL_CORPORATION_DETAILS]: FillCompanyDetails,
  [USCCORPIncorporationTasks.REVIEW_CORPORATION_DETAILS]: ApproveCompanyDetails,

  // Incorporation Filing
  [USCCORPIncorporationTasks.FILE_INCORPORATION]: MarkAsFiledComponent,
  [USCCORPIncorporationTasks.UPLOAD_INCORPORATION_DOCUMENTS]:
    USUploadIncorporationDocuments,
  [USCCORPIncorporationTasks.FILL_INCORPORATION_DETAILS]: IncorporationDetails,
  [USCCORPIncorporationTasks.SEND_EMAIL_UPDATE]:
    ServiceRequestSendEmailCardTask,

  // EIN Proof
  [USCCORPIncorporationTasks.UPLOAD_EIN_PROOF]: EINProof,

  // EIN Letter
  [USCCORPIncorporationTasks.UPLOAD_EIN_LETTER]: EINLetter,

  // Adopt Bylaws
  [USCCORPIncorporationTasks.SEND_BYLAWS_FOR_REVIEW]: SendBylawsForReview,
  [USCCORPIncorporationTasks.UPLOAD_SIGNED_BYLAWS]: UploadSignedBylaws,

  // Bank Account Creation
  [USCCORPIncorporationTasks.CLIENT_ADD_BANK_ACCOUNT]: AddBankAccountTask,
  [USCCORPIncorporationTasks.CLIENT_UPLOAD_BANK_WIRE_INSTRUCTIONS]:
    BankWireInstructionsUpload,

  // Drafting Share purchase agreement
  [USCCORPIncorporationTasks.CLIENT_REVIEWS_SHARE_PURCHASE_INSTRUCTIONS]:
    ShareHoldingInstructions,
  [USCCORPIncorporationTasks.CLIENT_UPLOADS_BANK_STATEMENTS]: BankStatements,
  [USCCORPIncorporationTasks.VERIFY_BANK_STATEMENTS]: VerifyBankStatements,
  [USCCORPIncorporationTasks.UPLOAD_SHAREHOLDING_DOCUMENTS]:
    ShareHoldingUploadDocuments,
  [USCCORPIncorporationTasks.CLIENT_UPLOADS_SIGNED_SHAREHOLDING_DOCUMENTS]:
    ClientUploadsSignedDocs,
  [USCCORPIncorporationTasks.VERIFY_SIGNED_DOCUMENTS]: VerifyDocuments,

  // BOI Filing
  [USCCORPIncorporationTasks.BOI_FILING_ACKNOWLEDGEMENT]:
    BOIFilingAcknowledgementUpload,
};
